import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_DRIVERS_DOCUMENTS_TYPES_DATA } from "./actionTypes";
import {
  fetchDriversDocumentsTypesSuccess,
  fetchDriversDocumentsTypesFailure,
} from "./actions";

function* fetchDriversDocumentsTypesDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/drivers-documents-types",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchDriversDocumentsTypesSuccess(response.data));
  } catch (error) {
    yield put(fetchDriversDocumentsTypesFailure(error.message));
  }
}

export default function* driversDocumentsTypesSaga() {
  yield takeEvery(FETCH_DRIVERS_DOCUMENTS_TYPES_DATA, fetchDriversDocumentsTypesDataSaga);
}
